import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import ParticipantsStore from '../../../../ParticipantsStore';
import { emptyFragment } from '../../../../EmptyFragment';
import BulkActions from '../BulkActions';
import {
  LoadingMore,
  Ready,
  Sorting,
  UpdatingQuery,
  UpdatingSearchParameters,
} from '../../../../ParticipantsStore/Types';

interface Props {
  store: ParticipantsStore;
  participantsState: LoadingMore | Ready | UpdatingQuery | UpdatingSearchParameters | Sorting;
}

const Actions: React.FC<Props> = ({ store, participantsState }) =>
  fromEmpty(participantsState.participantStores.filter((s) => s.participantChecked == true))
    .map((checkedParticipants) => (
      <BulkActions store={store} checkedParticipants={checkedParticipants} />
    ))
    .getOrElse(emptyFragment);

export default observer(Actions);
